import React from 'react';
// import { Link } from 'react-router-dom';
//import FontAwesome from 'react-fontawesome';
import { translate } from 'react-i18next';
import {gtmSend} from '../../../../helpers';
import {Icon} from '../../../Common/Icon';
// import * as CardComponents from '../../../Common/CardComponents';
// import {ProfileThumb} from '../../../Common/CardComponents';

import cx from '../../../../styles';

const PostsRelated = ({elems=[], t, isTrending=false, postData}) => {
    const onClick = (url) => {
        if(isTrending){
            gtmSend('dynamic', 'Trending posts', 'click', url);
        }
        else{
            gtmSend('click related posts', 'card-detail', 'click:related-post', url);
        }
    }

    let relValue = {};
    if(postData && postData.topic && !postData.topic.bot_index){
        relValue = {
            rel: "nofollow"
        };
    }

    return (
        <div className={cx("shadow-card", "related-article-posts")}>
            <div className={cx("header-wrap")}>
                <div>{isTrending ? t('trending-questions') : t('related_questions')}</div>
            </div>
            <ul>
                {
                    elems.map((elem, i) => {
                        return (
                            <li key={i}>
                                <div className={cx('related-post-title')} onClick={() => onClick(`/${elem.slug}`)}>
                                    {/*<div className={cx('related-post-title')}>*/}
                                        <a href={`/${elem.slug}`} {...relValue}>
                                            <span>{`${elem.title ? elem.title : ''} ${elem.message ? elem.message : ''}`}</span>
                                            <Icon name="chevron-right-regular-md" />
                                        </a>
                                    {/*</div>
                                    <p>
                                        <Link to={`/${elem.slug}`} {...relValue}>
                                            {elem.answer}
                                        </Link>
                                    </p>*/}
                                </div>

                                {/*<div className={cx("flex", "flex-center")}>
                                    <ProfileThumb img={elem.user_image ? elem.user_image : ""} altName={`${elem.fullname} profile icon`} />

                                    <div className={cx("related-post-username")}>{elem.fullname}</div>
                                </div>*/}
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    );
}

export default translate()(PostsRelated);
